import React, { useState, useRef, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { PlusIcon } from "../../../../styles/img/svg/PlusIcon";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../../_uiComponents/common/UiSliderArrows";
import UiIncentiveHistoryCard from "../../../_uiComponents/common/UiIncentiveHistoryCard";
import {
    UiSalesChainElement,
    UiSalesChainElementNoBgWr,
} from "../../../_uiComponents/common/UiSalesChainElements";
import { UiContentCol } from "../../../_uiComponents/common/UiPageElements";

import {
    UiCol,
    UiSingleRow,
} from "../../../_uiComponents/grid-container/GridContainer";
import { UiTable } from "../../../_uiComponents/common/UiTable";
import { UiSlider } from "../../../_uiComponents/common/UiSlider";
import { useDispatch, useSelector } from "react-redux";
import {
    campaignGetAreaManagerDealersRequest,
    campaignGetAreaManagersLeaguesRankSummaryRequest,
    campaignGetLeagueTableSummaryRequest,
} from "../../../../_redux/_actions";
import QuarterPerformanceChart from "./QuarterPerformanceChart";
import { participantJobRoleIds, participantTypeIds } from "../../../../_redux/_constants";
import UiDealerSelect from "../../../_uiComponents/common/UiDealerSelect";

export default function LeagueTableTeam(props) {
    const actionDispatch = useDispatch();
    const [selectArea, setSelectArea] = useState(null);

    const { leagueTeam, dealerships, areaManagerDealers, auth, leagueSummary, area, userProfileDetails } =
        useSelector((state) => {
            return {
                leagueTeam: state.campaign.leagueTeam,
                dealerships: state.auth.dealerships,
                areaManagerDealers: state.campaign,
                auth: state.auth,
                leagueSummary: state.campaign.areaManagerLeagueSummary,
                area:state?.auth?.userProfileDetails,
                userProfileDetails: state.auth.userProfileDetails,
            };
        });

        useEffect(() => {
            const { dealerCode } = dealerships || {};
            const { jobRoleId, roleId } = auth?.userProfileDetails || {};
            const { area: areaValue } = area || {};
        
            if (dealerCode && dealerCode.length > 0) {
                // When dealership exists and dealerCode is defined and not empty
                // actionDispatch(
                //     campaignGetLeagueTableSummaryRequest({
                //         dealerCode,
                //     }),
                // );
            } else if (
                dealerCode === undefined &&
                jobRoleId === participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
                roleId === participantTypeIds.PARTICIPANT &&
                areaValue !== 0
            ) {
                // When dealership is undefined, and conditions for the service area manager role are met
                // actionDispatch(
                //     campaignGetLeagueTableSummaryRequest({
                //         dealerCode: "",
                //     }),
                // );
            }
        }, [dealerships, auth, area]);

    useEffect(() => {
        const { jobRoleId, roleId } = auth?.userProfileDetails || {};
        const isServiceAreaManager = jobRoleId === participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER;
        const isParticipant = roleId === participantTypeIds.PARTICIPANT;
        
        if (isServiceAreaManager && isParticipant) {
            const areaId = area.area !== '0' ? undefined : '11';
            actionDispatch(campaignGetAreaManagersLeaguesRankSummaryRequest({ areaId }));
        }
    }, [auth?.userProfileDetails?.jobRoleId, area.area]);


    useEffect(() => {
        if (selectArea === null && userProfileDetails?.jobRoleId === participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER) {
            const areaId = area?.area === "0" ? "11" : area?.area;
            actionDispatch(campaignGetAreaManagerDealersRequest({
                particpantId: area?.participantIds[0],
                areaId
            }));
        }
    }, []);

    const TableHeaders = [
        { id: 1, th: "Rank" },
        { id: 2, th: "Dealer Name" },
        { id: 3, th: "Score (Points)" },
        { id: 4, th: "Location" },
        { id: 5, th: "Monthly above 100% Bonus" },
    ];

    const AreaManagerTableHeaders = [
        { id: 1, th: "Rank" },
        { id: 2, th: "Name" },
        { id: 3, th: "Score (Points)" },
        { id: 4, th: "Area" },
        // { id: 5, th: "Previous Period finishing position" },
    ];

    const TableSlider = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        centerPadding: 30,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ],
    };

    const containerRef = useRef();

    function deveideArray(arr, chunkSize) {
        let result = [];
        for (let i = 0; i < arr?.length; i += chunkSize) {
            let chunk = arr.slice(i, i + chunkSize);
            result.push(chunk);
        }
        return result;
    }

    let deveidedDealers = deveideArray(
        leagueTeam?.serviceManagersLeaguesDealerPerformanceDataList,
        8,
    );
    let leagueRankSummary = deveideArray(leagueSummary, 8);


    const SuperAreOption = [
        {code:11, name:11},
        {code:12, name:12},
        {code:13, name:13},
        {code:14, name:14},
        {code:15, name:15},
        {code:16, name:16},
        {code:17, name:17},
    ];

    // const ChangeDropDown = (value) => {
    //     setSelectArea(value);

    //     actionDispatch(campaignGetAreaManagersLeaguesRankSummaryRequest({
    //         areaId:value?.value
    //     }));

    //     actionDispatch(campaignGetAreaManagerDealersRequest({
    //         particpantId:area?.participantIds[0],
    //         areaId:value?.value
    //     }));
    // }


    return (
        <>
            <div className="sb-accordion-wrapper sb-league-table-content-wr">
                <div className="d-lg-flex">
                    <UiCol lg="12" className={props.className}>
                        <UiSingleRow>
                            <UiCol
                                lg="7"
                                className="sba-league-tbl-wr sb-league-provisional-table"
                            >
                                <UiContentCol>
                                    {auth?.userProfileDetails?.jobRoleId ===
                                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
                                    auth?.userProfileDetails.roleId ==
                                        participantTypeIds.PARTICIPANT ? (
                                        <>
                                            <div className="sb-league-tbl-top-heading-wr">
                                                <div className="sb-league-tabl-sec__header sb-league-tbl-heading-area">
                                                    <h4>League Table - AMAS</h4>
                                                    {/* <p>
                                                        {leagueTeam?.serviceManagerDealerName !==
                                                        null
                                                            ? `Your Dealership - ${leagueTeam?.serviceManagerDealerName}`
                                                            : ""}
                                                    </p> */}
                                                    

                                                </div>
                                                <div className="sb-league-table-heading">
                                                    {/* <h3>PROVISIONAL</h3> */}
                                                    <h3>FINAL</h3>
                                                </div>
                                            </div>
                                            <div className="sb-league-tabl-sec__incentive-joined-sec sb-league-table-team-peovincial-wr sb-league-incetive-tb">
                                                <UiSlider
                                                    UiSliderSettings={
                                                        TableSlider
                                                    }
                                                >
                                                    {leagueRankSummary?.map(
                                                        (
                                                            pageItems,
                                                            indexPage,
                                                        ) => {
                                                            return (
                                                                <div>
                                                                    <UiTable
                                                                        className="sb-white-bg-table sb-league-table-individual sb-league-table-team-provisional"
                                                                        tableHeader={
                                                                            AreaManagerTableHeaders
                                                                        }
                                                                    >
                                                                        {pageItems?.map(
                                                                            (
                                                                                item,
                                                                                indexItem,
                                                                            ) => (
                                                                                <tr
                                                                                    className={
                                                                                        item?.isParticipantArea ===
                                                                                        true
                                                                                            ? "sb-league-hl-pdr"
                                                                                            : ""
                                                                                    }
                                                                                >
                                                                                    <td>
                                                                                        <div>
                                                                                            {
                                                                                                item?.rank
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div>
                                                                                            {/* <img src={AvatarIcon} /> */}
                                                                                            <span>
                                                                                                <h4>
                                                                                                    {item?.areaManagerName !==
                                                                                                    null
                                                                                                        ? item?.areaManagerName
                                                                                                        : "N/A"}
                                                                                                </h4>
                                                                                            </span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="sbr-tble-cell">
                                                                                        <h4>
                                                                                            {
                                                                                                item?.score
                                                                                            }
                                                                                        </h4>
                                                                                    </td>
                                                                                    <td className="sbr-tble-cell">
                                                                                        <h4>
                                                                                            {
                                                                                                item?.area
                                                                                            }
                                                                                        </h4>
                                                                                    </td>
                                                                                    {/* <td className="sbr-tble-cell sb-leauge-table-team-quarter-finish">
                                                                                        <h4>
                                                                                        {item?.monthlyBonusPoints}
                                                                                        </h4>
                                                                                    </td> */}
                                                                                </tr>
                                                                            ),
                                                                        )}
                                                                    </UiTable>
                                                                </div>
                                                            );
                                                        },
                                                    )}
                                                </UiSlider>
                                                <div className="sb-province-table-last-update sb-last-update">
                                                    Updated:{" "}
                                                    <b>{"31 December, 2024"}</b>
                                                    {/* {
                                                        leagueTeam?.lastUpdatedDate
                                                    } */}
                                                </div>
                                                <UiTable className="sb-white-bg-table sb-league-table-individual sb-league-table-team-provisional sb-league-table-team-dealer-highlight">
                                                    {leagueTeam?.serviceManagersLeaguesDealerPerformanceDataList?.map(
                                                        (item, indexItem) => {
                                                            return (
                                                                item?.isParticipantDealerRecord && (
                                                                    <tr className="sb-league-hl-pdr">
                                                                        <td>
                                                                            <div>
                                                                                {
                                                                                    item?.rank
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <span>
                                                                                    <h4>
                                                                                        {
                                                                                            item?.dealerName
                                                                                        }
                                                                                    </h4>
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                        <td className="sbr-tble-cell">
                                                                            <h4>
                                                                                {
                                                                                    item?.dealerScore
                                                                                }
                                                                            </h4>
                                                                        </td>
                                                                        <td className="sbr-tble-cell">
                                                                            <h4>
                                                                                {
                                                                                    item?.dealerLocation
                                                                                }
                                                                            </h4>
                                                                        </td>
                                                                        <td className="sbr-tble-cell sb-leauge-table-team-quarter-finish">
                                                                            <h4>
                                                                            {item?.monthlyBonusPoints}
                                                                                {/* {item?.previousQuarterFinishingPosition !==
                                                                                ""
                                                                                    ? item?.previousQuarterFinishingPosition
                                                                                    : "-"} */}
                                                                            </h4>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            );
                                                        },
                                                    )}
                                                </UiTable>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="sb-league-tbl-top-heading-wr">
                                                <div className="sb-league-tabl-sec__header sb-league-tbl-heading-area">
                                                    <h4>
                                                        League Table - Area{" "}
                                                        {leagueTeam?.area}
                                                    </h4>
                                                    {/* <p>Your Dealership - {leagueTeam?.serviceManagerDealerName}</p> */}
                                                </div>
                                                <div className="sb-league-table-heading">
                                                    <h3>PROVISIONAL</h3>
                                                </div>
                                            </div>
                                            <div className="sb-league-tabl-sec__incentive-joined-sec sb-league-table-team-peovincial-wr sb-league-incetive-tb">
                                                <UiSlider
                                                    UiSliderSettings={
                                                        TableSlider
                                                    }
                                                >
                                                    {deveidedDealers?.map(
                                                        (
                                                            pageItems,
                                                            indexPage,
                                                        ) => {
                                                            return (
                                                                <div>
                                                                    <UiTable
                                                                        className="sb-white-bg-table sb-league-table-individual sb-league-table-team-provisional"
                                                                        tableHeader={
                                                                            TableHeaders
                                                                        }
                                                                    >
                                                                        {pageItems?.map(
                                                                            (
                                                                                item,
                                                                                indexItem,
                                                                            ) => (
                                                                                <tr
                                                                                    className={
                                                                                        item?.isParticipantDealerRecord ===
                                                                                        true
                                                                                            ? "sb-league-table-bg-highlight"
                                                                                            : ""
                                                                                    }
                                                                                >
                                                                                    <td>
                                                                                        <div>
                                                                                            {
                                                                                                item?.rank
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div>
                                                                                            {/* <img src={AvatarIcon} /> */}
                                                                                            <span>
                                                                                                <h4>
                                                                                                    {
                                                                                                        item?.dealerName
                                                                                                    }
                                                                                                </h4>
                                                                                            </span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="sbr-tble-cell">
                                                                                        <h4>
                                                                                            {
                                                                                                item?.dealerScore
                                                                                            }
                                                                                        </h4>
                                                                                    </td>
                                                                                    <td className="sbr-tble-cell">
                                                                                        <h4>
                                                                                            {
                                                                                                item?.dealerLocation
                                                                                            }
                                                                                        </h4>
                                                                                    </td>
                                                                                    <td className="sbr-tble-cell sb-leauge-table-team-quarter-finish">
                                                                                        <h4>
                                                                                        {item?.monthlyBonusPoints}
                                                                                            {/* {item?.previousQuarterFinishingPosition !==
                                                                                            ""
                                                                                                ? item?.previousQuarterFinishingPosition
                                                                                                : "-"} */}
                                                                                        </h4>
                                                                                    </td>
                                                                                </tr>
                                                                            ),
                                                                        )}
                                                                    </UiTable>
                                                                </div>
                                                            );
                                                        },
                                                    )}
                                                </UiSlider>
                                                <div className="sb-province-table-last-update sb-last-update">
                                                    Updated:{" "}
                                                    {
                                                        leagueTeam?.lastUpdatedDate
                                                    }
                                                </div>
                                                <UiTable className="sb-white-bg-table sb-league-table-individual sb-league-table-team-provisional sb-league-table-team-dealer-highlight">
                                                    {leagueTeam?.serviceManagersLeaguesDealerPerformanceDataList?.map(
                                                        (item, indexItem) => {
                                                            return (
                                                                item?.isParticipantDealerRecord && (
                                                                    <tr className="sb-league-hl-pdr ">
                                                                        <td>
                                                                            <div>
                                                                                {
                                                                                    item?.rank
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <span>
                                                                                    <h4>
                                                                                        {
                                                                                            item?.dealerName
                                                                                        }
                                                                                    </h4>
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                        <td className="sbr-tble-cell">
                                                                            <h4>
                                                                                {
                                                                                    item?.dealerScore
                                                                                }
                                                                            </h4>
                                                                        </td>
                                                                        <td className="sbr-tble-cell">
                                                                            <h4>
                                                                                {
                                                                                    item?.dealerLocation
                                                                                }
                                                                            </h4>
                                                                        </td>
                                                                        <td className="sbr-tble-cell sb-leauge-table-team-quarter-finish">
                                                                            <h4>
                                                                            {item?.monthlyBonusPoints}
                                                                                {/* {item?.previousQuarterFinishingPosition !==
                                                                                ""
                                                                                    ? item?.previousQuarterFinishingPosition
                                                                                    : "-"} */}
                                                                            </h4>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            );
                                                        },
                                                    )}
                                                </UiTable>
                                            </div>
                                        </>
                                    )}
                                    <div className="sb-target-chart-label">
                                        <h4>Targeted Products</h4>
                                        <div className="sb-target-chart-label-wr">
                                            <div className="sb-battery-label">
                                                <div className="sb-label-color-box"></div>
                                                <div className="sb-label-right-col">
                                                    <label>Battery </label>
                                                </div>
                                            </div>
                                            <div className="sb-wiper-blade">
                                                <div className="sb-label-color-box"></div>
                                                <div className="sb-label-right-col">
                                                    <label>Wiper Blades </label>
                                                </div>
                                            </div>

                                            <div className="sb-brake-pads">
                                                <div className="sb-label-color-box"></div>
                                                <div className="sb-label-right-col">
                                                    <label>Brake Pads</label>
                                                </div>
                                            </div>
                                            <div className="sb-brake-discs">
                                                <div className="sb-label-color-box"></div>
                                                <div className="sb-label-right-col">
                                                    <label>Brake Discs</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </UiContentCol>
                            </UiCol>
                            <UiCol lg="5" className="sb-sales-castrol-tracker">
                                <UiContentCol>
                                    <QuarterPerformanceChart salesQuarter={2} />
                                </UiContentCol>
                            </UiCol>
                        </UiSingleRow>
                    </UiCol>
                </div>
            </div>
        </>
    );
}
